(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
// The fetched recommendations are merged into the row the product page already rendered:
// its hand-picked pairings stay first, Shopify's picks fill the rest up to the row's cap,
// instead of replacing it wholesale.
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status < 200 || request.status >= 300) { return; }
    var container = document.createElement("div");
    container.innerHTML = request.response;
    var fetchedSection = container.querySelector(".related-products");
    if (fetchedSection === null) { return; }

    var grid = productRecommendationsSection.querySelector(".pdp-you-may-also-like__grid");
    if (grid === null) {
      // Nothing was rendered server side (the section was reloaded in the theme editor,
      // say): fall back to the theme's original behaviour and take the response whole.
      productRecommendationsSection.innerHTML = fetchedSection.innerHTML;
      grid = productRecommendationsSection.querySelector(".pdp-you-may-also-like__grid");
    } else {
      var maxProducts = parseInt(productRecommendationsSection.dataset.maxProducts, 10);
      if (isNaN(maxProducts) || maxProducts < 1) { maxProducts = 4; }
      var alreadyShown = {};
      var existingCards = grid.querySelectorAll("product-block[data-product-id]");
      var i;
      for (i = 0; i < existingCards.length; i++) {
        alreadyShown[existingCards[i].dataset.productId] = true;
      }
      var cardCount = existingCards.length;

      // One height for the whole row. The card's image sits in a
      // <div class="img-ar" style="--aspect-ratio: N"> written by snippets/image.liquid, and
      // assets/main.css turns that variable into the image's aspect-ratio. The two renders
      // can measure different products under the "tallest"/"shortest" thumbnail settings, so
      // an appended card could otherwise carry a different N and stand taller or shorter than
      // its neighbours. The server-rendered cards are the row, so their value wins: it is
      // copied onto every card appended below. With no server-rendered card there is nothing
      // to match, and the fetched cards are left exactly as they came.
      var rowAspectRatio = "";
      if (existingCards.length > 0) {
        var rowImageBox = existingCards[0].querySelector(".img-ar");
        if (rowImageBox !== null) {
          rowAspectRatio = rowImageBox.style.getPropertyValue("--aspect-ratio");
        }
      }

      var fetchedGrid = fetchedSection.querySelector(".pdp-you-may-also-like__grid");
      var incomingCards = fetchedGrid === null ? [] : fetchedGrid.querySelectorAll("product-block[data-product-id]");
      for (i = 0; i < incomingCards.length && cardCount < maxProducts; i++) {
        if (alreadyShown[incomingCards[i].dataset.productId]) { continue; }
        alreadyShown[incomingCards[i].dataset.productId] = true;
        if (rowAspectRatio !== "") {
          // Every image box in the card - the main photo and the hover/swipe photos.
          var incomingImageBoxes = incomingCards[i].querySelectorAll(".img-ar");
          for (var j = 0; j < incomingImageBoxes.length; j++) {
            incomingImageBoxes[j].style.setProperty("--aspect-ratio", rowAspectRatio);
          }
        }
        grid.appendChild(incomingCards[i]);
        cardCount++;
      }
    }

    // No cards at all after the merge: stay out of the way, as the theme did.
    if (grid !== null && grid.querySelector("product-block") !== null) {
      productRecommendationsSection.removeAttribute("hidden");
    } else {
      productRecommendationsSection.setAttribute("hidden", "");
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
